export const errorToString = (maybeError) => {
  if (!maybeError) return "Unknown error";
  if (typeof maybeError === "string") return maybeError;
  if (maybeError.message) return errorToString(maybeError.message);
  if (maybeError.error) return errorToString(maybeError.error);
  if (maybeError.payload) return errorToString(maybeError.payload);
  // eslint-disable-next-line no-console
  console.error("Couldn't interpret error", maybeError);
  try {
    return JSON.stringify(maybeError);
  } catch {
    return "Unknown error";
  }
};

export class ValidationError extends Error {
  constructor({ message, field }) {
    super(message);

    this.field = field;
    this.name = "ValidationError";
  }
}
